<template lang="pug">
    div.savedCard
        div Saved card:
        v-row
            v-col.col-12.col-sm-9

                // Last 4 digits
                v-text-field(
                    :label="$t('fields.cardNumber')"
                    :value="`XXXX-XXXX-XXXX-${card.last4}`"
                    outlined
                    disabled
                    hide-details
                )

            v-col.col-12.col-sm-3

                // Expiration date
                v-text-field(
                    :label="$t('fields.cardExpDate')"
                    :value="`${card.expiration_month}/${card.expiration_year}`"
                    outlined
                    disabled
                    hide-details
                )

        div.text-right.mt-2

            // Delete button
            v-btn(
                color="red lighten-3"
                outlined
                large
                :loading="isLoading"
                :disabled="isLoading"
                @click="deleteCard"
            ) {{ $t('fields.deleteCard') }}

</template>

<script>
    import VueTypes from 'vue-types';
    import { payments } from '~api';
    import { mapActions } from 'vuex';
    import { Handler } from '~services';

    export default {
        props: {
            card: VueTypes.object.def({}),
            deleteCallback: VueTypes.func.def(() => {}),
        },
        data() {
            return {
                isLoading: false,
            };
        },
        methods: {
            ...mapActions('prompt', ['show']),

            /**
             * Delete card
             * @returns {Promise<void>}
             */
            async deleteCard() {
                this.isLoading = true;

                // Show confirm modal window
                const promptParams = {
                    title: 'Delete card',
                    description: 'Please confirm delete',
                    confirmButton: 'delete',
                    declineButton: 'cancel',
                };
                const confirmed = await this.show(promptParams);

                if (!confirmed) return;

                const data = new FormData();
                data.append('pm', this.card.id);

                const resp = await payments.deleteCard(data);

                if (resp.ok) {
                    Handler.handleResponse(resp, resp.data, resp.data);
                    this.deleteCallback(resp.data);
                }

                this.isLoading = false;
            },
        },
    };
</script>

<style lang="stylus" scoped></style>
